import "./WorkList.scss";
import { GoArrowRight } from "react-icons/go";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Fragment, useContext, useEffect, useState } from "react";
import { baseUrl } from "../../../utils/apiData";
import { mainContext } from "../../../utils/WebContext";
import { images } from "../../../utils/images";

const WorkList = ({ dataList }) => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const { involvedService } = useContext(mainContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [page]);

  return (
    <section className="work_sec p_t p_b">
      <div className="content_wrap">
        {dataList?.length > 0 ? (
          <Fragment>
            <div className="work_grid">
              {dataList?.map((data) => {
                return (
                  <motion.div
                    initial={{ translateY: 32, opacity: 0 }}
                    whileInView={{ translateY: 0, opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeInOut" }}
                    viewport={{ once: true }}
                    className="work_card"
                    key={data?._id}
                    onClick={() => navigate(`/service/${data?.slug}`)}
                  >
                    <div className="img_wrap">
                      <img src={`${baseUrl}/${data?.image}`} alt="Work" />
                    </div>
                    <div className="work_info">
                      <h4>{data?.name}</h4>
                      <p className="t_18">{data?.sort_content}</p>
                      <button type="button">
                        <p>View More</p>
                        <GoArrowRight />
                      </button>
                    </div>
                  </motion.div>
                );
              })}

              <motion.div
                initial={{ translateY: 32, opacity: 0 }}
                whileInView={{ translateY: 0, opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="work_card"
                onClick={() => navigate("/get-involved/stories")}
              >
                <div className="img_wrap">
                  <img src={images.story} alt="Work" />
                </div>
                <div className="work_info">
                  <h4>Stories</h4>
                  <p className="t_18">View our stories</p>
                  <button type="button">
                    <p>View More</p>
                    <GoArrowRight />
                  </button>
                </div>
              </motion.div>
            </div>
          </Fragment>
        ) : (
          <p className="text-center">Data not found...</p>
        )}
      </div>
    </section>
  );
};

export default WorkList;
